import React from "react";
import { StyledPageInput } from "./styled";
import { PageInputProps } from "../../types/PageInputProps";

const PageInput = ({ pageIndex, onChangePageIndex }: PageInputProps) => {
  return (
    <StyledPageInput>
      <input
        style={{
          border: "none",
          outline: "none",
          width: "100%",
          color: "#000",
          fontFamily: "Inter",
          fontSize: "1rem",
          fontStyle: "normal",
          fontWeight: 500,
          lineHeight: "normal",
          textAlign: "center",
        }}
        value={pageIndex}
        onChange={(e) => onChangePageIndex(e.currentTarget.value)}
      />
    </StyledPageInput>
  );
};

export default PageInput;
